import { myAxios } from "./axios";

// Get leads per sales representative
export function getLeadsPerSalesRep(payload = {}, { page, limit } = {}) {
  return myAxios.get("/reports/leads-per-rep", {
    params: { page, limit, ...payload },
  });
}

// Get clients contacted
export function getClientsContacted(payload = {}, { page, limit } = {}) {
  return myAxios.get("/reports/clients-contacted", {
    params: { page, limit, ...payload },
  });
}

// Get successful deals (requires statusId param)
export function getSuccessfulDeals(statusId, payload = {}, { page, limit } = {}) {
  return myAxios.get(`/reports/successful-deals/${statusId}`, {
    params: { page, limit, ...payload },
  });
}

// Get budget summary
export function getBudgetSummary(payload = {}, { page, limit } = {}) {
  return myAxios.get("/reports/budget-summary", {
    params: { page, limit, ...payload },
  });
}

// Get top services
export function getTopServices(payload = {}, { page, limit } = {}) {
  return myAxios.get("/reports/top-services", {
    params: { page, limit, ...payload },
  });
}

// Get campaign delivery tracking
export function getCampaignTracking(payload = {}, { page, limit } = {}) {
  return myAxios.get("/reports/campaign-tracking", {
    params: { page, limit, ...payload },
  });
}

// Get sales funnel
export function getSalesFunnel(payload = {}, { page, limit } = {}) {
  return myAxios.get("/reports/sales-funnel", {
    params: { page, limit, ...payload },
  });
}

// Get total leads
export function getTotalLeads(payload = {}, { page, limit } = {}) {
  return myAxios.get("/reports/total-leads", {
    params: { page, limit, ...payload },
  });
}

// Get deals by status level
export function getDealsByStatusLevel(payload = {}, { page, limit } = {}) {
  return myAxios.get("/reports/deals-by-level", {
    params: { page, limit, ...payload },
  });
}

// Get delivered logs
export function getDeliveredLogs(payload = {}, { page = 1, limit = 10 } = {}) {
  return myAxios.get("/reports/delivered-logs", {
    params: { page, limit, ...payload },
  });
}

// Get undelivered logs
export function getUndeliveredLogs(payload = {}, { page = 1, limit = 10 } = {}) {
  return myAxios.get("/reports/undelivered-logs", {
    params: { page, limit, ...payload },
  });
}
